module.exports = __webpack_public_path__ + "rand_logo-d900ced6c2bc7c651c40d7738e3069c2.png";